import type { FilterDefinition } from '@/components/filters/list-filter-types'
import { FilterOptionList } from '@/components/filters/filter-menu'

export type CallEvaluationsTab = 'attention' | 'in_progress' | 'completed' | 'all'

export type CallEvaluationsFilterState = {
  search: string
  status: CallEvaluationsTab
}

export type CallEvaluationsFilterCtx = {
  counts: Record<CallEvaluationsTab, number>
}

export const CALL_EVALUATIONS_STATUS_OPTIONS: Array<{ value: CallEvaluationsTab; label: string }> = [
  { value: 'attention', label: 'Needs attention' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'all', label: 'All calls' },
]

function statusOptionLabel(
  option: { value: CallEvaluationsTab; label: string },
  counts: Record<CallEvaluationsTab, number>,
): string {
  return `${option.label} (${counts[option.value]})`
}

export const CALL_EVALUATIONS_FILTER_DEFINITIONS: FilterDefinition<
  CallEvaluationsFilterState,
  CallEvaluationsFilterCtx
>[] = [
    {
      key: 'status',
      label: 'Status',
      displayValue: (filters, ctx) => {
        const option = CALL_EVALUATIONS_STATUS_OPTIONS.find((opt) => opt.value === filters.status)
        return option ? statusOptionLabel(option, ctx.counts) : 'Needs attention'
      },
      isNonDefault: (filters) => filters.status !== 'attention',
      reset: (filters) => ({ ...filters, status: 'attention' }),
      renderPopover: ({ filters, onChange, ctx }) => (
        <FilterOptionList
          type="single"
          options={CALL_EVALUATIONS_STATUS_OPTIONS.map((option) => ({
            value: option.value,
            label: statusOptionLabel(option, ctx.counts),
          }))}
          value={filters.status}
          onValueChange={(value) => onChange({ ...filters, status: value as CallEvaluationsTab })}
        />
      ),
    },
  ]
